import en from './en.json'
import ru from './ru.json'
import zh from './zh.json'
import ar from './ar.json'

export const languages = {
  en, ru, zh, ar
}
